import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import { getInterfaceLanguage } from "./requestLanguage";

const initialLang = getInterfaceLanguage();

const resources = {
  en: { translation: en },
};

const loadLanguage = async (lang) => {
  if (lang === "en") {
    await i18n.changeLanguage("en");
    return;
  }
  if (resources[lang]) {
    i18n.changeLanguage(lang);
    return;
  }
  try {
    const module = await import(`./locales/${lang}.json`);
    resources[lang] = { translation: module.default };
    i18n.addResourceBundle(lang, "translation", module.default);
    i18n.changeLanguage(lang);
  } catch (err) {
    console.warn(`Language file for ${lang} not found, using English`);
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

const rtlLanguages = new Set(["ar", "ur"]);
const updateDocumentLanguage = (lng = "en") => {
  document.documentElement.lang = lng || "en";
  document.documentElement.dir = rtlLanguages.has(String(lng).split("-")[0])
    ? "rtl"
    : "ltr";
};

// Update HTML language and reading direction together.
updateDocumentLanguage(initialLang);
i18n.on("languageChanged", (lng) => {
  updateDocumentLanguage(lng);
});

if (initialLang !== "en") {
  loadLanguage(initialLang);
}

export { loadLanguage };
export default i18n;
